import dynamic from "next/dynamic"

const DynamicAudioIllustrated = dynamic(() => import("./DynamicAudioIllustrated"))
const DynamicButton = dynamic(() => import("./DynamicButton"))
const DynamicImage = dynamic(() => import("./DynamicImage"))
const DynamicTrustpilot = dynamic(() => import("./DynamicTrustpilot"))
const DynamicPageSection = dynamic(() => import("./DynamicPageSection"))
const DynamicAnimation = dynamic(() => import("./DynamicAnimation"))
const DynamicAppDownloadButtons = dynamic(() => import("./DynamicAppDownloadButtons"))
const DynamicAsideIllustration = dynamic(() => import("./DynamicAsideIllustration"))
const DynamicCollapsingGrid = dynamic(() => import("./DynamicCollapsingGrid"))
const DynamicCollapsingStack = dynamic(() => import("./DynamicCollapsingStack"))
const DynamicGlobalReference = dynamic(() => import("./DynamicGlobalReference"))
const DynamicGridItem = dynamic(() => import("./DynamicGridItem"))
const DynamicHero = dynamic(() => import("./DynamicHero"))
const DynamicIframe = dynamic(() => import("./DynamicIframe"))
const DynamicIOEligibilityCheck = dynamic(() => import("./DynamicIOEligibilityCheck"), {
    ssr: false,
})
const DynamicMargin = dynamic(() => import("./DynamicMargin"))
const DynamicMotivation = dynamic(() => import("./DynamicMotivation"))
const DynamicTypography = dynamic(() => import("./DynamicTypography"))
const DynamicTypeform = dynamic(() => import("./DynamicTypeform"))
const DynamicYoutube = dynamic(() => import("./DynamicYoutube"))
const DynamicAnimatedNumber = dynamic(() => import("./DynamicAnimatedNumber"))
const DynamicFadeIn = dynamic(() => import("./DynamicFadeIn"))
const DynamicSlideIn = dynamic(() => import("./DynamicSlideIn"))
const DynamicParallax = dynamic(() => import("./DynamicParallax"))

// Green Energy
const DynamicGreenEnergy = dynamic(() => import("./DynamicGreenEnergy"))
const DynamicEnergyBought = dynamic(() => import("./DynamicGreenEnergy/DynamicEnergyBought"))
const DynamicEnergyConsumed = dynamic(() => import("./DynamicGreenEnergy/DynamicEnergyConsumed"))
const DynamicEnergyDistributed = dynamic(
    () => import("./DynamicGreenEnergy/DynamicEnergyDistributed")
)
const DynamicEnergyHouseholds = dynamic(
    () => import("./DynamicGreenEnergy/DynamicEnergyHouseholds")
)
const DynamicEnergyInvest = dynamic(() => import("./DynamicGreenEnergy/DynamicEnergyInvest"))
const DynamicEnergyMobility = dynamic(() => import("./DynamicGreenEnergy/DynamicEnergyMobility"))
const DynamicEnergyOrigin = dynamic(() => import("./DynamicGreenEnergy/DynamicEnergyOrigin"))
const DynamicRenewableEnergy = dynamic(() => import("./DynamicGreenEnergy/DynamicRenewableEnergy"))
const DynamicGreenEnergyHeader = dynamic(
    () => import("./DynamicGreenEnergy/DynamicGreenEnergyHeader")
)

export const components = {
    greenEnergy: DynamicGreenEnergy,
    greenEnergyBought: DynamicEnergyBought,
    greenEnergyConsumed: DynamicEnergyConsumed,
    greenEnergyDistributed: DynamicEnergyDistributed,
    greenEnergyHouseholds: DynamicEnergyHouseholds,
    greenEnergyInvest: DynamicEnergyInvest,
    greenEnergyMobility: DynamicEnergyMobility,
    greenEnergyOrigin: DynamicEnergyOrigin,
    greenEnergyHeader: DynamicGreenEnergyHeader,
    greenEnergyRenewable: DynamicRenewableEnergy,
    animatedNumber: DynamicAnimatedNumber,
    slideIn: DynamicSlideIn,
    fadeIn: DynamicFadeIn,
    parallax: DynamicParallax,
    animation: DynamicAnimation,
    appDownloadButtons: DynamicAppDownloadButtons,
    asideIllustration: DynamicAsideIllustration,
    audioIllustrated: DynamicAudioIllustrated,
    button: DynamicButton,
    collapsingGrid: DynamicCollapsingGrid,
    collapsingStack: DynamicCollapsingStack,
    globalReference: DynamicGlobalReference,
    gridItem: DynamicGridItem,
    hero: DynamicHero,
    iframe: DynamicIframe,
    image: DynamicImage,
    IOEligibilityCheck: DynamicIOEligibilityCheck,
    margin: DynamicMargin,
    motivation: DynamicMotivation,
    pageSection: DynamicPageSection,
    typography: DynamicTypography,
    trustpilot: DynamicTrustpilot,
    typeform: DynamicTypeform,
    youtube: DynamicYoutube,
}
